import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TakeMeasureApiService } from './take-measure-api.service';
import { TakeMeasureEffects } from './take-measure.effects';
import {
  takeMeasureInitialState,
  takeMeasureReducer
} from './take-measure.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('takeMeasure', takeMeasureReducer, {
      initialState: takeMeasureInitialState
    }),
    EffectsModule.forFeature([TakeMeasureEffects])
  ],
  providers: [TakeMeasureApiService]
})
export class TakeMeasureStoreModule {}
